export default {
  lettering: "letterings",
  pangrams: "pangrams",
  sentences: "paragraphs",
  gotchas: "gotchas",
  ABCs: "alphabet",
  glyphs: null,
  kerning: null,
  languages: null,
};
